import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ resource, hasRequestedAllocationTransfer, destinationResource }) =>
    present(
      (hasRequestedAllocationTransfer
        ? repository.removeResourceFromPlanzoneAndTransferAllocations(
            resource,
            destinationResource,
          )
        : repository.removeResourceFromPlanzone(resource)
      )
        .then(() => ({
          resource,
          hasRequestedAllocationTransfer,
          destinationResource,
        }))
        .catch(() =>
          Promise.reject({
            resource,
            hasRequestedAllocationTransfer,
            destinationResource,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
